import { iconObj } from 'components/Menu/NewMenu/constants';
import {
  IconBox,
  StyledCategoryButton,
  StyledNavLink,
} from 'components/Menu/NewMenu/subcomponents/CategoryItem/styled';
import { TagBadge } from './styled';
import { makeEnvironmentUrl } from 'utils/development-tools';
import { Tooltip } from 'react-tooltip';

// O link do item pode ser uma rota relativa (ex: '/dashboard') ou uma URL absoluta vinda da
// API (ex: 'https://front.lkp.dev.br/dashboard') — em ambos os casos o que importa pra
// comparar com a rota atual é só o pathname.
const getLinkPathname = link => {
  if (!link) return '';

  try {
    return new URL(link).pathname;
  } catch {
    return link;
  }
};

// Páginas com subrotas (ex: /dashboard/*, /relatorios/*) navegam pra um pathname mais longo
// que o link cadastrado no menu (ex: /dashboard/visao-geral). Por isso a comparação precisa
// ser "a rota atual começa pelo link do item", não uma checagem de substring qualquer — senão
// o item nunca fica marcado como ativo fora da rota raiz exata.
export const checkIsActive = (link, pathname) => {
  const linkPathname = getLinkPathname(link).toLowerCase();
  if (!linkPathname) return false;

  const currentPathname = pathname.toLowerCase();
  return currentPathname === linkPathname || currentPathname.startsWith(`${linkPathname}/`);
};

export const MenuLinkItem = ({ label, link, isExternal = false, isChildren = false, disabled, tag }) => {
  const index = new Date().getTime();

  const linkProps = {
    to: link,
  };
  const isActive = checkIsActive(link, location.pathname);

  const commonButtonProps = {
    isChildren,
    disabled: disabled,
    isActive,
  };

  if (isExternal || link === '') {
    return (
      <StyledCategoryButton key={label} {...commonButtonProps}>
        {isExternal ? (
          <>
            <a
              onClick={event => (disabled ? event.preventDefault() : null)}
              href={makeEnvironmentUrl(link)}
              disabled={disabled}
              data-tooltip-id={`external-${index}-${link}`}
              data-tooltip-content="Você não tem acesso a esse item."
              data-tooltip-place="top-start"
            >
              {!isChildren && (
                <IconBox isActive={isActive} disabled={disabled}>
                  {iconObj[label]}
                </IconBox>
              )}
              <span>{label}</span>
              {tag && <TagBadge>{tag}</TagBadge>}
            </a>
            {disabled && (
              <Tooltip
                id={`external-${index}-${link}`}
                style={{ borderRadius: 10 }}
                disableTooltip={elem => elem.getAttribute('disabled')}
              />
            )}
          </>
        ) : (
          <div>
            {!isChildren && (
              <IconBox isActive={isActive} disabled={disabled}>
                {iconObj[label]}
              </IconBox>
            )}
            <a
              onClick={event => (disabled ? event.preventDefault() : null)}
              href={makeEnvironmentUrl(link)}
              disabled={disabled}
              data-tooltip-id={`single-${index}`}
              data-tooltip-content="Você não tem acesso a esse item."
              data-tooltip-place="top-start"
            >
              {label}
              {tag && <TagBadge>{tag}</TagBadge>}
            </a>
            {disabled && (
              <Tooltip
                id={`single-${index}`}
                style={{ borderRadius: 10 }}
                disableTooltip={elem => elem.getAttribute('disabled')}
              />
            )}
          </div>
        )}
      </StyledCategoryButton>
    );
  }

  return (
    <StyledCategoryButton key={label} {...commonButtonProps}>
      <StyledNavLink
        {...linkProps}
        onClick={event => (disabled ? event.preventDefault() : null)}
        disabled={disabled}
        data-tooltip-id={`tooltip-${index}-${link}`}
        data-tooltip-content="Você não tem acesso a esse item."
        data-tooltip-place="top-start"
      >
        {!isChildren && (
          <IconBox isActive={isActive} disabled={disabled}>
            {iconObj[label]}
          </IconBox>
        )}
        <span>{label}</span>
        {tag && <TagBadge>{tag}</TagBadge>}
      </StyledNavLink>
      {disabled && (
        <Tooltip
          id={`tooltip-${index}-${link}`}
          style={{ borderRadius: 10 }}
          disableTooltip={elem => elem.getAttribute('disabled')}
        />
      )}
    </StyledCategoryButton>
  );
};
